export default __webpack_public_path__ + "static/media/P_Palhaco.35271149.mp3";